<template>
  <div
    :id="data? data.url: ''"
    class="page"
    :class="mobile_view? 'mobile-view': ''"
  >
    <template v-if="!loading">
      <Banner :banner="page.banner" />
      <section
        id="content_section"
        class="container bg-white text-left"
      >
        <div
          class="row"
          style="position: relative"
        >
          <div
            class="py-4 pb-5"
            :class="page.sidemenu? 'col-lg-9 order-lg-2': 'col-lg-12'"
          >
            <div
              v-if="page.sidemenu"
              class="float-right"
            >
              <button
                type="button"
                class="btn btn-link btn-sm toggle_menu_btn"
                @click="toggleSideMenu()"
              >
                <template v-if="collapsed">
                  <i class="fa fa-chevron-left" />
                  {{ $t("component.toggle_btn.show_sidemenu") }}
                </template>
                <template v-else>
                  <i class="fa fa-chevron-right" />
                  {{ $t("component.toggle_btn.hide_sidemenu") }}
                </template>
              </button>
            </div>
            <Breadcrumb :items="[{ name: page.title, url: path }]" />
            <div class="content py-4">
              <h1
                v-if="page.heading"
                class="articleTitle text-osc"
              >
                {{ page.heading }}
              </h1>
              <div
                v-if="!loading && data"
                class="articleBodyFullWidth"
              >
                <div
                  v-if="page.heading"
                  class="articleLike mb-4"
                >
                  <ShareBtn />
                </div>
                <template v-if="data.photo">
                  <b-link
                    id="upload_btn"
                    class="btn btn-primary postion_btn"
                    to="/santa_public_upload"
                  >
                    Upload
                  </b-link>
                </template>
                <div class="articleContent">
                  <div
                    v-if="data.body"
                    v-lazy-container="{ selector: 'img' }"
                    v-html="filterHTML(data.body)"
                  />
                  <template v-if="data.photo && data.photo.length > 0">
                    <CardsStack
                      v-if="!use_masonry"
                      class="cards_stack"
                      :cards="visibleCards"
                      :current-index="currentIndex"
                      @cardAccepted="handleCardAccepted"
                      @cardRejected="handleCardRejected"
                      @cardSkipped="handleCardSkipped"
                      @hideCard="removeCardFromDeck"
                    />
                    <div
                      v-if="use_masonry && !resizing"
                      class="container p-0 mt-3 masonry_container"
                    >
                      <div
                        :id="`photo_${data.photo[0].item_id}`"
                        :key="`photo_${data.photo[0].item_id}`"
                        class="card album_photo hero_photo"
                      >
                        <a
                          :id="`album_photo_trigger_${data.photo[0].item_id}`"
                          class="d-block album_photo_trigger first_trigger"
                          data-fancybox="gallery"
                          data-type="image"
                          :data-caption="data.photo[0].caption"
                          :data-options="fancyOptions"
                          :href="getAssetLink(data.photo[0].relative_path)"
                        >
                          <img
                            class="card-img-top album_photo_thumb"
                            :src="getAssetLink(data.photo[0].relative_path)"
                          >
                          <div class="card-img-overlay">
                            <h2 class="text-white m-0">+ {{ data.photo.length - showMax }}</h2>
                          </div>
                        </a>
                      </div>
                      <div
                        v-masonry
                        transition-duration="0.3s"
                        item-selector=".card"
                        :origin-top="true"
                        :horizontal-order="false"
                      >
                        <template v-for="(item, i) in data.photo">
                          <template v-if="i === 0" />
                          <div
                            v-else-if="i<(showMax) || i>(showMax)"
                            :id="`photo_${item.item_id}`"
                            :key="`photo_${item.item_id}`"
                            v-masonry-tile
                            class="card album_photo"
                            :class="i>(showMax)? 'd-none': ''"
                          >
                            <a
                              :id="`album_photo_trigger_${item.item_id}`"
                              class="d-block album_photo_trigger"
                              data-fancybox="gallery"
                              data-type="image"
                              :data-caption="item.caption"
                              :data-options="fancyOptions"
                              :href="getAssetLink(item.relative_path)"
                            >
                              <img
                                class="card-img-top album_photo_thumb"
                                :src="getImageThumb(item)"
                              >
                            </a>
                          </div>
                          <!-- <div
                            v-else
                            v-masonry-tile
                            class="card album_photo last_thumb"
                            :key="`photo_${item.item_id}`"
                            :id="`photo_${item.item_id}`"
                          >
                            <a
                              class="d-block album_photo_trigger last_trigger"
                              :id="`album_photo_trigger_${item.item_id}`"
                              data-fancybox="gallery"
                              data-type="image"
                              :data-options="getImageOptions(item)"
                              :href="getAssetLink(item.relative_path)"
                            >
                              <img
                                class="card-img-top album_photo_thumb"
                                :src="getImageThumb(item)"
                              >
                              <div class="card-img-overlay">
                                <h2 class="text-white m-0">+ {{data.photo.length - showMax}}</h2>
                              </div>
                            </a>
                          </div>-->
                        </template>
                      </div>
                    </div>
                  </template>
                  <Gallery
                    v-if="data.videos"
                    :videos="data.videos"
                  />
                </div>
              </div>
            </div>
          </div>
          <SideMenu
            v-if="page.sidemenu"
            class="col-lg-3 py-4 order-lg-1"
            :class="collapsed?'':' active'"
            :data="page.sidemenu"
          />
        </div>
      </section>
      <section
        id="donate_btn_section"
        class="container bg-white py-4 clearfix d-none d-md-block"
      >
        <DonateBtn
          v-view.once
          class="animated fadeInRight"
        />
      </section>
    </template>
  </div>
</template>
<script>
import Banner from "@/components/Banner.vue";
import DonateBtn from "@/components/DonateBtn.vue";
import SideMenu from "@/components/SideMenu.vue";
import ShareBtn from "@/components/ShareBtn.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Gallery from "@/components/Gallery.vue";
import CardsStack from "@/components/CardsStack.vue";

// import fancyBox from "vue-fancybox";
import * as _ from "lodash";

export default {
  name: "Media",
  components: {
    Banner,
    DonateBtn,
    SideMenu,
    ShareBtn,
    Breadcrumb,
    Gallery,
    CardsStack
  },
  data() {
    var to = this.$router.history.current;
    return {
      // default
      path: to.path.substr(1),
      type: to.params.type,
      loading: true,
      page: null,
      data: null,
      showMax: localStorage.getItem("album_show_max") || 20,
      collapsed: true,
      mobile_view: false,
      fancyOptions: this.getImageOptions(),
      resizing: false,
      use_masonry: true,
      // use_masonry: process.env.NODE_ENV === "production" && process.env.VUE_APP_API_URL == "http://api-oscprod.scmp.com", // Use card
      visibleCards: [],
      currentIndex: 0
    };
  },
  watch: {
    $route(to) {
      this.path = to.path.substr(1);
      this.collapsed = true;
      this.type = to.params.type;
      this.init();
    }
  },
  mounted() {
    this.init();
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    handleCardAccepted() {
      // console.log("handleCardAccepted");
    },
    handleCardRejected() {
      // console.log("handleCardRejected");
    },
    handleCardSkipped() {
      // console.log("handleCardSkipped");
    },
    removeCardFromDeck() {
      // True current index from the orginal list
      this.currentIndex++;
      this.visibleCards.shift();
    },
    onResize() {
      let resizing = false;
      if (
        document.documentElement.clientWidth > this.$config.breakpoints.sidemenu
      ) {
        if (this.mobile_view) {
          this.mobile_view = false;
          this.showMax = localStorage.getItem("album_show_max") || 20;
          resizing = true;
        }
      } else {
        if (!this.mobile_view) {
          this.mobile_view = true;
          this.showMax = localStorage.getItem("album_show_max_sm") || 10;
          resizing = true;
        }
      }
      if (resizing) {
        this.resizing = true;
        setTimeout(() => {
          this.resizing = false;
        }, 2);
      }
    },
    toggleSideMenu() {
      this.collapsed = !this.collapsed;
    },
    init() {
      this.loading = true;

      this.page = {
        // Default Settings for page
        sidemenu: null,
        banner: null,
        title: this.$t("page." + this.type),
        heading: null
      };
      this.$http
        .get(`public_upload/${this.type}`)
        .then(response => {
          if (response.data.success) {
            this.data = response.data.data;

            this.page.banner = this.data.image;
            this.page.title =
              this.getDataValue("name", this.data) || this.page.title;
            this.page.heading =
              this.getDataValue("headline", this.data) || this.page.heading;
            this.$route.meta.title = this.page.title;
            this.$route.meta.desc = this.data.desc;
            this.$meta().refresh(); // Important!

            if (this.data && this.data.left_menus) {
              if (this.data.tab_menus && this.data.tab_menus.length > 0) {
                if (this.data.left_menus && this.data.left_menus.length > 0) {
                  let item = {
                    url: "news",
                    name: "SCMP",
                    type: "list",
                    sub_menus: this.data.tab_menus
                  };
                  this.data.left_menus.unshift(item);
                } else {
                  this.data.left_menu_header = this.$t("component.category");
                  this.data.left_menus = this.data.tab_menus;
                }
              }
              this.page.sidemenu = {
                parent: this.path,
                title: this.data.left_menu_header,
                items: this.data.left_menus
              };
            }
            if (this.type == "video") {
              setTimeout(function() {
                window.initGallery();
              }, 1000);
            } else {
              this.visibleCards =
                this.data && this.data.photo ? this.data.photo : [];
            }
          } else throw { response: response };
        })
        .catch(error => {
          let response = error.response;
          if (
            response &&
            (response.status === 404 || response.status === 401)
          ) {
            this.$router.replace("/404");
          }
          // else {}
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getImageThumb(item) {
      if (!_.isEmpty(item.other)) {
        var arr = JSON.parse(item.other);
        if (arr.thumb) {
          return this.getAssetLink(arr.thumb);
        }
      }
      return this.getAssetLink(item.relative_path);
    },
    getImageOptions() {
      return JSON.stringify({
        loop: true,
        thumbs: { autoStart: true, axis: "x" },
        buttons: ["slideShow", "thumbs", "close"]
      });
    }
  }
};
</script>
<style scoped lang="scss" src="../assets/scss/list.scss"></style>
<style scoped lang="scss">
.masonry_container .card.album_photo.hero_photo {
  max-width: none;
  width: 100%;

  img.card-img-top.album_photo_thumb {
    width: 100%;
  }
}
.cards_stack {
  margin-top: 80px;

  // @media screen and (max-width: 600px) {
  //   margin-top: 20px;
  // }
}
</style>
